import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CompanyService } from '../../configuration/company/company.service.service';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { ICreateRouteGroup } from './interfaces/create-route-group.interface';
import { IUpdateRouteGroup } from './interfaces/update-route-group.interface';
import RouteGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-group/route-group.entity';
import { RouteGroupService } from './route-group.service';
import { RouteItineraryService } from '../route/route-itinerary/route-itinerary.service';
import { TranslocoModule } from '@ngneat/transloco';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { RouteGroupItinerary } from './route-itinerary/route-itinerary.component';
import { getCode } from 'app/utils/method';
import { ExportService } from 'app/layout/export-overlay/export-overlay.service';
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from 'app/layout/export-overlay/tasks/core/export-task.interfaces';
import { RouteGroupExport } from './exports/route-group.export';
import { ROUTE_GROUP_TITLE } from './exports/route-group.constants';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { BONUS_HANDLING_OPTIONS } from 'app/shared/constants/lists.constant';



@Component({
  selector: 'app-route-group',
  standalone: true,
  templateUrl: './route-group.component.html',
  styleUrl: './route-group.component.scss',
  imports: [
    TranslocoModule,
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent, 
    NgSelectModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    RouteGroupExport
  ],
})

export class RouteGroupComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  displayedColumnsI: string[] = ["days", "action", "status", "actions"];
  displayedColumns: string[] = ["name", "company","statusId", "actions"];
  currentCreateRouteGroup: ICreateRouteGroup = this.initializeCreateRouteGroup();
  currentUpdateRouteGroup: RouteGroupAttributes | undefined;

  companyList: CompanyAttributes[] = [];
  selectedCompanyIds: string[] = [];

  dataSource: RouteGroupAttributes[] = [];
  searchQuery = '';
  totalItems = 0;
  pageSize = 50;
  pageIndex:number = 1;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  daysList: { day: string; value: number }[] = [
    { day: "Lunes", value: 1 },
    { day: "Martes", value: 2 },
    { day: "Miércoles", value: 3 },
    { day: "Jueves", value: 4 },
    { day: "Viernes", value: 5 },
    { day: "Sábado", value: 6 },
    { day: "Domingo", value: 7 },
  ];

  bonusHandlingOptions = BONUS_HANDLING_OPTIONS;
  
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("addModalItinerary") addModalItinerary!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;

    selectedStatuses: number [] = [];
    form: FormGroup;

  // Lazy loading flags
  loadFiltersData = false;
  companiesLoaded = false;

  constructor(
    private readonly companyService: CompanyService,
    private readonly itineraryService: RouteItineraryService,
    private readonly routeGroupService: RouteGroupService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private routeGroupExport: RouteGroupExport,
    private fb: FormBuilder
  ) {
      this.form = this.fb.group({
      companyId: [],
    });
   }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private initializeCreateRouteGroup(): ICreateRouteGroup {
    return {  name: "", companyId: "" };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount(); 
  }

  private fetchCompanies(): void {
    if (this.companiesLoaded) return;
    this.companiesLoaded = true;
    this.companyService.findToComboBox().subscribe((res) => {
      this.companyList = res.data;
    });
  }

  private ensureModalDataLoaded(): void {
    this.fetchCompanies();
  }

  findAllWithCount(): void {
    // const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" = this.sort.direction === "asc" ? "ASC" : "DESC";
    const companyCodes = this.getSelectedCompanyCodes(this.selectedCompanyIds);

    let filter: IFilters = {
      companyId: this.form.get("companyId").value,
      status: this.selectedStatuses,
    }
    
    this.routeGroupService
      .findAllWithCount(
        { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.searchQuery, sort: sortField, sortDirection: sortDirection },
        filter
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof RouteGroupAttributes {
    const validSortFields: (keyof RouteGroupAttributes)[] = ["name", "statusId"];
    return validSortFields.includes(this.sort.active as keyof RouteGroupAttributes) ? (this.sort.active as keyof RouteGroupAttributes) : "name";
  }

  private getSelectedCompanyCodes(selectedIds: string[]): number[] {
    return selectedIds.map((id) => this.companyList.find((company) => company._id.toString() === id)?.id );
  }

  onCompanySelectionChange(selectedIds: string[]): void {
    this.selectedCompanyIds = selectedIds;
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      // this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          //this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: RouteGroupAttributes): string {
    return item._id.toString();
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  clearFilters(): void {
    this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.form.reset({companyId:null})
    this.findAllWithCount();
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }

  openCreateModal(): void {
    this.ensureModalDataLoaded();
    this.currentCreateRouteGroup = this.initializeCreateRouteGroup();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createRouteGroup());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(routeArea: RouteGroupAttributes): void {
    this.ensureModalDataLoaded();
    this.currentUpdateRouteGroup = { ...routeArea };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateRouteGroup(routeArea._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createRouteGroup(): void {
    this.routeGroupService.create(this.currentCreateRouteGroup).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
        this.dialogRefAdd.close()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateRouteGroup(id: string): void {
    if (this.currentUpdateRouteGroup) {
      const updatedRouteGroup: IUpdateRouteGroup = { 
        companyId: this.currentUpdateRouteGroup.company._id.toString(),
         ...this.currentUpdateRouteGroup };

      this.routeGroupService.update(id, updatedRouteGroup).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.findAllWithCount();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }


  
  // openItineraryModal(route: RouteGroupAttributes): void {
  //   this.currentUpdateRouteGroup = { ...route };
  //   this.dialog
  //     .open(this.addModalItinerary, { panelClass: "form-modal-interlocutor" })
  //     .afterClosed()
  //     .subscribe((result) => {
  //       if (result) {
  //       }
  //     });
  // }

   

  openItineraryModal(existingData?) {
    const dialogRef = this.dialog.open(RouteGroupItinerary, {
      //panelClass: ".form-modal-interlocutor",
      width: "90%",
      data: existingData,
      disableClose: true
    });
    dialogRef.afterClosed()  .subscribe((result) => {
      if (result) {
      }
    });
  }

  
  getDayNames(days: number[]): string {
    return days
      .map((day) => {
        const foundDay = this.daysList.find((d) => d.value === day);
        return foundDay ? foundDay.day : "";
      })
      .join(", ");
  }


  // openAddItineraryModal(existingData?) {
  //   const dialogRef = this.dialog.open(AddSubRouteItinerary, {
  //     panelClass: ".form-modal-interlocutor",
  //     data: {existingData, type: 3}
  //   });
  //   dialogRef.afterClosed().subscribe((result) => {
  //     if (result) {
  //       if (existingData) {
  //         this.updateItinerary(result);
  //       } else {
  //         this.createItinerary(result);
  //       }
  //     }
  //   });
  // }

  createItinerary(result): void {
    this.itineraryService
      .createEmbedded(
        this.currentUpdateRouteGroup._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.itineraryService
            .findByRouteId(this.currentUpdateRouteGroup._id.toString())
            .subscribe((data) => {
              this.currentUpdateRouteGroup.itinerary = data?.data;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updateItinerary(result): void {
    this.itineraryService
      .updateEmbedded(
        this.currentUpdateRouteGroup._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
            duration: 3000,
          });
          this.itineraryService
            .findByRouteId(this.currentUpdateRouteGroup._id.toString())
            .subscribe((data) => {
              this.currentUpdateRouteGroup.itinerary = data?.data;
            });
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al actualizar el registro",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  onStatusChange(event: boolean, routeArea: RouteGroupAttributes): void {
    const originalStatusId = routeArea.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedRouteGroup = { ...routeArea, statusId: updatedStatusId };

    this.routeGroupService.update(routeArea._id.toString(), updatedRouteGroup).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        routeArea.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
      }
    });
  }

  openDeleteDialog(routeArea: RouteGroupAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: routeArea, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(routeArea._id.toString()));
  }

  delete(id: string): void {
    this.routeGroupService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  //exportar
  onExportButtonPressed() {
    if (!this.routeGroupExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: ROUTE_GROUP_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.routeGroupExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
